import BaseService from '@/services/BaseService'
import {http} from "./config"

class NotificacaoService extends BaseService {
    constructor(){
        super('/v1/notificacoes')
    }

    visualizar(item){
        return http.get(`/v1/notificacoes/${item.id}`)
    }
}

export default new NotificacaoService